"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getFoundryDefaultHeaders_1 = __importDefault(require("../../getFoundryDefaultHeaders"));
var originHeader_1 = require("@fuze/apis-core/dist/originHeader");
var http_client_1 = __importDefault(require("@fuze/apis-core/dist/http-client"));
var pagination_1 = require("@fuze/apis-core/dist/pagination");
var didUtilities_1 = require("../utils/didUtilities");
/**
 * Get a list of DIDs
 *
 * @param baseUrl The base url of the API
 * @param wardenToken The authentication token for the user making the request
 * @param origin An identifier for the application make the API request
 * @param organizationCode The organization code that all of the DIDs must belong to
 * @param portStatuses (string[]) A list of possible port statuses that the client is looking for
 *        passing in undefined or an empty list will not filter on portStatus
 * @param inUse (boolean) Whether to show in-use DIDs (in-use means that the DID is assigned to a service)
 *        passing in undefined/null will not filter on inUse
 * @param automation (boolean) Whether to show automation DIDs - by default, automation DIDs are NOT included by the API
 * @param tollFree (boolean) Whether to show toll free DIDs - by default, toll free DIDs ARE included by the API
 * @param q (string) Area code for which to retrieve DIDs
 * @param pagination A PaginationRequest object used to filter the results
 */
function getDIDs(baseUrl, wardenToken, origin, organizationCode, portStatuses, inUse, automation, tollFree, q, countryCode, pagination) {
    if (organizationCode === void 0) { organizationCode = ""; }
    if (portStatuses === void 0) { portStatuses = []; }
    if (inUse === void 0) { inUse = false; }
    if (automation === void 0) { automation = false; }
    if (tollFree === void 0) { tollFree = false; }
    if (q === void 0) { q = null; }
    if (countryCode === void 0) { countryCode = null; }
    if (pagination === void 0) { pagination = pagination_1.defaultPaginationRequest; }
    var serializedPagination = (0, pagination_1.serializePagination)(pagination);
    var serializedParameters = (0, didUtilities_1.serializeParameters)(inUse, automation, tollFree, portStatuses, q, countryCode);
    var url = baseUrl + "/v1/dids?organization=" + organizationCode + "&" + serializedPagination + serializedParameters;
    return (0, http_client_1.default)({
        method: "GET",
        url: url,
        headers: __assign(__assign({}, (0, getFoundryDefaultHeaders_1.default)(wardenToken)), (0, originHeader_1.createOriginHeader)(origin))
    }).then(function (response) {
        return response.data;
    });
}
exports.default = getDIDs;
